@if (!mostrarFormulario) {
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Dados PCMSO">
        <div card-header>
            @if (abaSelecionada === 'ATIVAS') {
                <app-botao-acoes [label]="'Ações'" [items]="acoesNovo" [appCan]="rolePcmsoEditar" [appCanUf]="pessoa()?.uf" />
            }
        </div>

        <app-tab-container class="pcmso-tab-switch" [options]="optionsTab" [(selected)]="abaSelecionada" (onChanged)="onToggleAba()" [useHeader]="false">
            <app-tab-content [value]="'ATIVAS'">
                <app-custom-table [metadata]="empresasTableMetadata" [data]="empresasExibidasTabela" [showExpandButton]="false" [first]="first" [rows]="rows" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)" />
            </app-tab-content>

            <app-tab-content [value]="'INATIVAS'">
                <app-custom-table [metadata]="empresasTableMetadata" [data]="empresasExibidasTabela" [showExpandButton]="false" [first]="first" [rows]="rows" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)" />
            </app-tab-content>
        </app-tab-container>
    </app-card-content>
}

@if (mostrarFormulario) {
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-file-edit" title="Dados PCMSO">
        <div card-header class="flex items-center gap-2">
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" size="small" (onClick)="voltarParaTabela()" pTooltip="Voltar" tooltipPosition="left" />
            @if ((registrosPcmso.length > 0 || modoCriacao) && abaSelecionada === 'ATIVAS') {
                @if (!modoEdicao) {
                    <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [appCan]="rolePcmsoEditar" [appCanUf]="pessoa()?.uf" />
                }
            }
        </div>

        <form [formGroup]="pcmsoForm">
            <div class="flex flex-col gap-4">
                <!-- Dados principais -->
                <app-card-content [headerColor]="false" icon="pi pi-id-card" title="Identificação">
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                        <div class="field">
                            <label for="tipoRegistro" class="font-semibold block mb-2">Tipo de Registro</label>
                            <p-select
                                id="tipoRegistro"
                                formControlName="tipoRegistro"
                                [options]="tipoRegistroOptions"
                                optionLabel="label"
                                optionValue="value"
                                appendTo="body"
                                placeholder="Selecione o tipo de registro"
                                [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao"
                            />
                        </div>

                        <div class="field">
                            <label for="numeroRegistro" class="font-semibold block mb-2">Número do Registro</label>
                            <input pInputText id="numeroRegistro" formControlName="numeroRegistro" placeholder="Número do registro" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                        </div>

                        <div class="field">
                            <label for="cnpj" class="font-semibold block mb-2">CNPJ</label>
                            <p-inputmask id="cnpj" formControlName="cnpj" mask="99.999.999/9999-99" placeholder="__.___.___/____-__" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [disabled]="!modoEdicao" />
                            @if (campoInvalido('cnpj')) {
                                <small class="erro-campo">{{ mensagemErroCampo('cnpj') }}</small>
                            }
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label for="razaoSocial" class="font-semibold block mb-2">Razão Social / Nome</label>
                            <input pInputText id="razaoSocial" formControlName="razaoSocial" placeholder="Razão social" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('razaoSocial')) {
                                <small class="erro-campo">{{ mensagemErroCampo('razaoSocial') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- Funcionamento -->
                <app-card-content [headerColor]="false" icon="pi pi-cog" title="Funcionamento">
                    <div class="grid grid-cols-1 gap-4 mb-4">
                        <div class="field">
                            <label for="divisaoAreaSetor" class="font-semibold block mb-2">Divisão / Área / Setor</label>
                            <input pInputText id="divisaoAreaSetor" formControlName="divisaoAreaSetor" placeholder="Divisão / Área / Setor" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                        </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label for="nrFuncionarios" class="font-semibold block mb-2">Nº Funcionários</label>
                            <input
                                pInputText
                                id="nrFuncionarios"
                                formControlName="nrFuncionarios"
                                type="number"
                                min="0"
                                inputmode="numeric"
                                placeholder="Número de funcionários"
                                [attr.aria-invalid]="campoInvalido('nrFuncionarios') ? true : null"
                                [attr.aria-describedby]="campoInvalido('nrFuncionarios') ? 'erro-nrFuncionarios' : null"
                                [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [readonly]="!modoEdicao"
                            />
                            @if (campoInvalido('nrFuncionarios')) {
                                <small class="erro-campo" [id]="'erro-nrFuncionarios'">{{ mensagemErroCampo('nrFuncionarios') }}</small>
                            }
                        </div>

                        <div class="field">
                            <label for="classificacaoRisco" class="font-semibold block mb-2">Classificação de Risco</label>
                            <p-select
                                id="classificacaoRisco"
                                formControlName="classificacaoRisco"
                                [options]="classificacaoRiscoOptions()"
                                optionLabel="label"
                                optionValue="value"
                                appendTo="body"
                                placeholder="Selecione a classificação de risco"
                                [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                [disabled]="!modoEdicao"
                            />
                        </div>
                    </div>
                </app-card-content>

                <!-- Contato -->
                <app-card-content [headerColor]="false" icon="pi pi-user" title="Contato">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <label for="emailEmpresa" class="font-semibold block mb-2">E-mail da Empresa</label>
                            <input pInputText id="emailEmpresa" formControlName="emailEmpresa" type="email" placeholder="email@empresa.com" [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao" />
                            @if (campoInvalido('emailEmpresa')) {
                                <small class="erro-campo">{{ mensagemErroCampo('emailEmpresa') }}</small>
                            }
                        </div>
                    </div>
                </app-card-content>

                <!-- Coordenação -->
                <app-card-content [headerColor]="false" icon="pi pi-file-edit" title="Coordenação">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="field">
                            <div class="grid grid-cols-2 gap-2">
                                <div>
                                    <label for="coordenacaoDataInicio" class="block mb-2 text-sm">Data Início</label>
                                    <p-inputmask id="coordenacaoDataInicio" formControlName="coordenacaoDataInicio" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [disabled]="!modoEdicao" />
                                    @if (campoInvalido('coordenacaoDataInicio')) {
                                        <small class="erro-campo">{{ mensagemErroCampo('coordenacaoDataInicio') }}</small>
                                    }
                                </div>
                                <div>
                                    <label for="coordenacaoDataFim" class="block mb-2 text-sm">Data Fim</label>
                                    <p-inputmask id="coordenacaoDataFim" formControlName="coordenacaoDataFim" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao ? 'w-full readonly-input' : 'w-full'" [disabled]="!modoEdicao" />
                                </div>
                            </div>
                        </div>
                    </div>
                </app-card-content>

                <!-- Documentação Comprobatória -->
                @if (registrosPcmso.length > 0 || modoCriacao) {
                    <app-card-content [headerColor]="false" icon="pi pi-paperclip" title="Documentação Comprobatória">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                            <div class="field">
                                <label for="documentacaoDescricao" class="font-semibold block mb-2">Descrição do Documento</label>
                                <input
                                    pInputText
                                    id="documentacaoDescricao"
                                    formControlName="documentacaoDescricao"
                                    placeholder="Ex.: Contrato de prestação de serviços"
                                    [class]="!modoEdicao ? 'w-full readonly-input' : 'w-full'"
                                    [readonly]="!modoEdicao"
                                />
                            </div>

                            <div class="field">
                                @if (modoCriacao) {
                                    <label class="font-semibold block mb-2">Anexo PDF (até 10 MB) - Novo registro</label>
                                    <div class="flex items-center gap-2">
                                        <input type="file" accept=".pdf" class="hidden" #pdfInput (change)="onSelectPdf($event)" />
                                        <p-button label="Anexar PDF" icon="pi pi-upload" [disabled]="!modoEdicao" (onClick)="pdfInput.click()"></p-button>
                                        @if (arquivoPdfNome) {
                                            <span class="text-sm text-gray-600 truncate">{{ arquivoPdfNome }}</span>
                                        }
                                        @if (arquivoPdfNome) {
                                            <p-button icon="pi pi-times" severity="secondary" [text]="true" [rounded]="true" (onClick)="removerPdf()" pTooltip="Remover anexo"></p-button>
                                        }
                                    </div>
                                    @if (exibirErroPdfCriacao()) {
                                        <small class="erro-campo">Anexo PDF obrigatório para novo registro.</small>
                                    }
                                }
                            </div>
                        </div>

                        @if (!modoCriacao) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div class="field">
                                    <label class="font-semibold block mb-2">Anexo do Registro Atual</label>
                                    <div class="flex items-center gap-2">
                                        <p-button label="Visualizar Anexo" icon="pi pi-eye" (onClick)="visualizarAnexo()" [disabled]="!registroAtual?.nuRegistro"></p-button>
                                    </div>
                                </div>

                                <div class="field">
                                    @if (modoEdicao) {
                                        <label class="font-semibold block mb-2">Substituir Anexo (registro existente)</label>
                                    }
                                    <div class="flex items-center gap-2">
                                        <input type="file" accept=".pdf" class="hidden" #pdfReplaceInput (change)="onSelectSubstituirPdf($event)" />
                                        @if (modoEdicao) {
                                            <p-button label="Selecionar PDF" icon="pi pi-upload" [disabled]="!modoEdicao || !registroAtual?.nuRegistro" (onClick)="pdfReplaceInput.click()"></p-button>
                                        }
                                        @if (substituicaoPdfNome) {
                                            <span class="text-sm text-gray-600 truncate">{{ substituicaoPdfNome }}</span>
                                        }
                                        @if (substituicaoPdfNome) {
                                            <p-button label="Substituir" icon="pi pi-check" severity="success" (onClick)="substituirAnexo(pdfReplaceInput)" [disabled]="!modoEdicao"></p-button>
                                        }
                                        @if (substituicaoPdfNome) {
                                            <p-button icon="pi pi-times" severity="secondary" [text]="true" [rounded]="true" (onClick)="removerSubstituicaoPdf()" pTooltip="Limpar seleção"></p-button>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </app-card-content>
                }
            </div>

            @if (modoEdicao && abaSelecionada === 'ATIVAS') {
                <div class="flex justify-end gap-2 mt-4">
                    <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="cancelarEdicao()"></p-button>
                    <p-button label="Salvar" icon="pi pi-check" (onClick)="salvarDados()" [disabled]="pcmsoForm.invalid || loading()" [appCan]="rolePcmsoEditar" [appCanUf]="pessoa()?.uf"></p-button>
                </div>
            }
        </form>
    </app-card-content>
}
